import type { IUser } from '@ui/components';

/** Separates the authenticated sender identity from the effective creator cache owner. */
export const getCreatorMessageCenterIdentity = (
  user?: Pick<IUser, 'id' | 'companyUser'> | null,
) => ({
  authenticatedUserId: user?.id,
  effectiveCreatorId: user?.companyUser || user?.id,
});
